export default {
  topMenu: {
    openSettings: 'Open settings',
    showAbout: 'Show general information',
    about: 'About ORS',
    pinSidebar: 'Pin sidebar',
    settingsTooltip: 'Click here if you want to adjust app settings'
  }
}
